import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedBarChart } from '../visualizations/AnimatedBarChart';
import { MarketSizeComparison } from '../visualizations/MarketSizeComparison';
export function Slide14MarketPotential() {
  const swedenData = [{
    label: 'Product Media',
    value: 6.8,
    displayValue: '6.8 mdr SEK'
  }, {
    label: 'Event Marketing',
    value: 3.1,
    displayValue: '3.1 mdr SEK'
  }, {
    label: 'Outdoor',
    value: 1.6,
    displayValue: '1.6 mdr SEK'
  }, {
    label: 'Total Media Spend',
    value: 49,
    displayValue: '49 mdr SEK',
    highlight: true
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-177">
      <motion.h2 className="text-5xl font-bold text-white mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-178">
        Market Potential
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-179">
        {/* Sweden Stats */}
        <div className="space-y-8 bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-180">
          <h3 className="text-3xl font-bold text-[#4fd1c5] mb-4" data-id="element-181">Sweden</h3>
          <AnimatedBarChart data={swedenData} maxValue={50} data-id="element-182" />
        </div>

        {/* Global Stats */}
        <div className="flex flex-col justify-center space-y-8" data-id="element-183">
          <h3 className="text-3xl font-bold text-[#ffd700] mb-4 text-center" data-id="element-184">
            Global Opportunity
          </h3>

          <MarketSizeComparison swedenValue={49} globalValue={112} swedenLabel="SE Total Media" globalLabel="Global Marketing Auto" data-id="element-185" />

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.5
        }} className="text-center mt-8" data-id="element-186">
            <p className="text-2xl text-[#4fd1c5] font-medium" data-id="element-187">
              Sampling is Universal
            </p>
            <p className="text-white/60 mt-2" data-id="element-188">
              Every brand needs to get products into hands
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}